import { useToast } from "@/hooks/use-toast";
import { Toast, ToastAction, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Toaster() {
  const { toasts, dismiss } = useToast();
  const backdropOpen = toasts.some((t) => t.open);

  return (
    <ToastProvider>
      {backdropOpen && (
        <div
          className="fixed inset-0 z-[99] bg-slate-900/50 backdrop-blur-sm duration-200 animate-in fade-in-0"
          onClick={() => dismiss()}
        />
      )}
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isError = variant === "destructive";
        return (
          <Toast key={id} variant={variant} {...props}>
            <span
              className={cn(
                "flex h-16 w-16 items-center justify-center rounded-full",
                isError ? "bg-destructive/10 text-destructive" : "bg-emerald-500/10 text-emerald-600",
              )}
            >
              {isError ? <AlertTriangle className="h-8 w-8" /> : <CheckCircle2 className="h-8 w-8" />}
            </span>
            <div className="grid gap-1.5">
              {title && <ToastTitle className="text-lg font-bold">{title}</ToastTitle>}
              {description && (
                <ToastDescription className="text-sm leading-relaxed text-muted-foreground">{description}</ToastDescription>
              )}
            </div>
            {action ?? (
              <ToastAction
                altText="OK"
                className={cn(
                  "mt-1 inline-flex h-11 min-w-[150px] items-center justify-center rounded-full border-0 px-8 text-sm font-semibold text-white shadow-sm transition-colors hover:text-white",
                  isError ? "bg-destructive hover:bg-destructive/90" : "bg-primary hover:bg-primary/90",
                )}
              >
                OK
              </ToastAction>
            )}
            <ToastClose className="opacity-60 hover:opacity-100" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
